import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { OVERVIEW_ROUTE } from '@rci/self-serve-fido/app.constant';
import { BehaviorSubject } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { breadCrumbsConfig } from './breadcrumbs.config';
import { BreadcrumbsData, RouteBreadcrumbsConfig } from './breadcrumbs.model';

@Injectable({ providedIn: 'root' })
export class BreadcrumbsService {
  private readonly rootBreadcrumb: BreadcrumbsData = {
    copy: 'subnav.overview',
    alt: 'subnav.overview',
    val: OVERVIEW_ROUTE,
  };

  private readonly breadcrumbSubject = new BehaviorSubject<BreadcrumbsData[]>([]);
  private readonly breadcrumbRoutes: RouteBreadcrumbsConfig[] = breadCrumbsConfig;

  constructor(private readonly router: Router) {
    router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(event => {
          const url = (event as NavigationEnd).url.slice(1);
          const breadcrumbRoute = this.breadcrumbRoutes.find(
            route => (!route.useRegEx && url === route.key) || (route.useRegEx && route.regexp.test(url)),
          );
          const noBreadcrumbs = /view-bill|payments/.test(url);
          if (breadcrumbRoute && !noBreadcrumbs) {
            this.setBreadCrumb(breadcrumbRoute.breadcrumbsData);
          } else {
            this.breadcrumbSubject.next([]);
          }
        }),
      )
      .subscribe();
  }
  get breadcrumbs$() {
    return this.breadcrumbSubject.asObservable();
  }
  setBreadCrumb(breadcrumbs: BreadcrumbsData[]) {
    this.breadcrumbSubject.next([this.rootBreadcrumb, ...breadcrumbs]);
  }

  addBreadcrumbsData(breadcrumbsConfigData: RouteBreadcrumbsConfig[]) {
    breadcrumbsConfigData.forEach(config => this.addBreadcrumbData(config));
  }

  addBreadcrumbData(breadcrumbConfigData: RouteBreadcrumbsConfig) {
    const isAvailable = this.breadcrumbRoutes.some(route => route.key && route.key === breadcrumbConfigData.key);
    if (!isAvailable) {
      this.breadcrumbRoutes.push(breadcrumbConfigData);
    }
  }
}
